import { render, staticRenderFns } from "./ResetPin.vue?vue&type=template&id=fa67e7da&"
import script from "./ResetPin.vue?vue&type=script&lang=js&"
export * from "./ResetPin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports